<div class="section pb-24" [formGroup]="parentForm">
  <div class="pb-16" fxLayout="row" fxLayoutAlign="start center">
    <div class="h2 secondary-text">SEO</div>
  </div>
  <app-form-group [form]="parentForm.get('seo')" [controls]="controls"></app-form-group>
</div>
